import { render, staticRenderFns } from "./online_work.vue?vue&type=template&id=e82b73b4&scoped=true"
import script from "./online_work.vue?vue&type=script&lang=js"
export * from "./online_work.vue?vue&type=script&lang=js"
import style0 from "./online_work.vue?vue&type=style&index=0&id=e82b73b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82b73b4",
  null
  
)

export default component.exports